import { u as o } from "./index-6a632112.mjs";
import { c as i } from "./themes-5f0b3c3d.mjs";
import "react/jsx-runtime";
import "react";
const d = o.div`
  background-color: ${i.brandTwilight[400]};
  width: 100%;
  height: 1px;
  display: block;
  flex-shrink: 0;
`;
export {
  d as Divider
};
